module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-07.4534598d.jpeg";